import React from 'react'
import CardFilterDateTiny from '../CardFilterDateTiny'
import PrintTiny from '../PrintTiny'
import styled from 'styled-components'
import InputFilter from '../InputFilter'

const CardWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-left: 0.3rem;

`
const Input = styled.input`
    font-family: "Poppins";
    font-weight: 500;
    border:none;
    text-indent: 21px;
    font-size:1.0rem;
    border:1px solid #313131dd;
    width: 427px;
    height: 40px;
    border-radius: 5px;

`
const ContainerInput = styled.div`
    width: 290px;

`

const FilterTiny = ({structure}) => {
    return(

        <CardWrapper>

            <ContainerInput>
            <InputFilter placeholder='Pesquise por sku'/>
            </ContainerInput>
            <CardFilterDateTiny/>
            <PrintTiny structure={structure}/>
        </CardWrapper>

    )
}

export default FilterTiny